module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0121.png.7bfe51c4.jpg";